import { resizeTextArea } from './resize-text-area'

$(function () {
  resizeTextArea(".export_line_items_description")
})
